import React from 'react';
import { Chip } from 'components';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Participant } from '@app/api';

import { usePanel, useParticipantTags } from 'queries';

interface Props {
  participant: Participant;
}

const useStyles = createUseStyles((theme: Theme) => ({
  tags: {
    marginRight: theme.marginBase,
    marginTop: theme.marginBase / 2,
  },
  button: {
    marginTop: theme.marginBase * 2,
  },
  inputContainer: {
    backgroundColor: theme.colors.grayBackground,
    marginTop: theme.marginBase,
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
  },
}));

export const ParticipantProfileDetailsTags = ({ participant }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { data: panel, error } = usePanel(participant.panelId, {
    retry: false,
  });

  const { data: tags } = useParticipantTags(participant.id);
  const canEdit = panel && !error;

  if (!canEdit) {
    return null;
  }

  return (
    <div>
      {tags && tags.length ? (
        tags.map((tag) => (
          <Chip customColor={tag.color} key={tag.id} className={classes.tags}>
            {tag.name}
          </Chip>
        ))
      ) : (
        <> - </>
      )}
    </div>
  );
};
